﻿import { GuiDetailGeneric } from "../../GuiDetailGeneric";
export class GuiDetailAvalMatching extends GuiDetailGeneric {
    constructor() {
        super("GuiDetailAvalMatching");
    }
}
